<template>
  <div>
    <v-layout>
      <v-dialog v-model="show" :fullscreen="$vuetify.breakpoint.smAndDown" lazy>
        <v-toolbar color="blue darken-2" dark>
          <v-icon large left>email</v-icon>
          <v-toolbar-title>Email</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-select
                    v-model="emailTemplateId"
                    :items="emailTemplates"
                    item-text="name"
                    item-value="id"
                    label="Template"
                    @change="getTemplate(emailTemplateId)"
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-if="!editTo"
                    v-model="emailText"
                    label="To"
                    readonly
                    hint="Select to edit email addresses"
                    persistent-hint
                    @click.native="editTo = !editTo"
                  ></v-text-field>
                  <v-combobox
                    v-else
                    v-model="editedItem.emails"
                    :items="emailList"
                    label="To"
                    chips
                    multiple
                  >
                    <template slot="selection" slot-scope="data">
                      <v-chip
                        :selected="data.selected"
                        :disabled="data.disabled"
                        class="v-chip--select-multi"
                        close
                        @input="data.parent.selectItem(data.item)"
                      >
                        {{ data.item }}
                      </v-chip>
                    </template>
                  </v-combobox>
                </v-flex>
                <v-flex xs12>
                  <v-combobox
                    v-model="editedItem.cc"
                    :items="ccList"
                    label="Cc"
                    multiple
                    chips
                    @click.native="loadItem()"
                  >
                    <template
                      slot="selection"
                      slot-scope="data"
                    >
                      <v-chip
                        :key="JSON.stringify(data.item)"
                        :selected="data.selected"
                        :disabled="data.disabled"
                        class="v-chip--select-multi"
                        close
                        @input="data.parent.selectItem(data.item)"
                      >
                        {{ data.item }}
                      </v-chip>
                    </template>
                  </v-combobox>
                </v-flex>
                <v-flex xs12>
                  <v-combobox
                    v-model="editedItem.bcc"
                    :items="bccList"
                    label="Bcc"
                    multiple
                    chips
                    @click.native="loadItem()"
                  >
                    <template
                      slot="selection"
                      slot-scope="data"
                    >
                      <v-chip
                        :key="JSON.stringify(data.item)"
                        :selected="data.selected"
                        :disabled="data.disabled"
                        class="v-chip--select-multi"
                        close
                        @input="data.parent.selectItem(data.item)"
                      >
                        {{ data.item }}
                      </v-chip>
                    </template>
                  </v-combobox>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="editedItem.subject"
                    v-on:keyup.enter="save"
                    label="Subject"
                    @click.native="loadItem()"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <wysiwyg v-model="editedItem.myHTML" @click.native="loadItem()" />
                </v-flex>
                <v-flex xs12>
                  <v-btn color="blue darken-1" flat v-on:click="addFiles()">
                    <v-icon left dark>mdi-paperclip</v-icon>
                    Add Attachments
                  </v-btn>
                </v-flex>
                <v-flex xs12>
                  <label>
                    <input type="file" id="files" ref="files" multiple v-on:change="handleFileUploads"/>
                  </label>
                </v-flex>
                <v-flex xs12>
                  <v-list two-line subheader>
                    <v-subheader v-if="files.length > 0" inset>Files</v-subheader>
                    <v-divider v-if="files.length > 0"></v-divider>
                    <template v-for="(file, index) in files">
                      <v-list-tile avatar :key="index">
                        <v-list-tile-avatar>
                          <v-icon
                            v-if="file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/excel' || file.type === 'text/csv'"
                            color="green darken-2"
                            large
                          >
                            mdi-file-excel
                          </v-icon>
                          <v-icon
                            v-else-if="file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || file.type === 'application/msword'"
                            color="blue darken-2"
                            large
                          >
                            mdi-file-word
                          </v-icon>
                          <v-icon
                            v-else-if="file.type === 'image/png' || file.type === 'image/jpeg'"
                            color="yellow darken-2"
                            large
                          >
                            mdi-file-image
                          </v-icon>
                          <v-icon
                            v-else-if="file.type === 'application/pdf'"
                            color="red darken-2"
                            large
                          >
                            mdi-file-pdf
                          </v-icon>
                          <v-icon
                            v-else-if="file.type === 'application/zip'"
                            color="orange darken-2"
                            large
                          >
                            mdi-zip-box
                          </v-icon>
                          <v-icon
                            v-else
                            color="gray darken-2"
                            large
                          >
                            mdi-file-document-box
                          </v-icon>
                        </v-list-tile-avatar>

                        <v-list-tile-content inset>
                          <v-list-tile-title>{{ file.name }}</v-list-tile-title>
                          <v-list-tile-sub-title>{{ file.lastModified }}</v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                          <v-icon v-on:click="removeFile( index )" color="red">block</v-icon>
                        </v-list-tile-action>
                      </v-list-tile>
                      <v-divider :key="file.name"></v-divider>
                    </template>
                  </v-list>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              flat
              v-if="saving"
              @click.stop="show=false"
            >Cancel</v-btn>
            <v-btn
              color="blue darken-1"
              transition="fade-transition"
              v-if="!saving"
              flat
              @click.stop="show=false"
            >Close</v-btn>
            <v-btn
              color="blue darken-1"
              dark
              transition="fade-transition"
              v-if="saving"
              @click.native="save"
            >Send</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        :multi-line=true
        :timeout="6000"
      >
        {{ snackbar.message }}
        <v-btn
          dark
          flat
          @click="snackbar.show = false"
        >
          Close
        </v-btn>
      </v-snackbar>
    </v-layout>
  </div>
</template>

<script>
import Api from '@/services/Api'

export default {
  props: ['visible', 'items', 'selectedItems', 'emailTemplates', 'emailTemplateId', 'rows', 'section'],

  data () {
    return {
      myId: this.$store.state.user.id,
      myName: this.$store.state.user.fullName,
      myEmail: this.$store.state.user.email,
      saving: false,
      snackbar: {
        show: false,
        color: '',
        message: ''
      },
      editedItem: {
        emails: this.selectedItems,
        from: this.$store.state.user.fullName + ' <' + this.$store.state.user.email + '>',
        replyTo: this.$store.state.user.fullName + ' <' + this.$store.state.user.email + '>',
        cc: [],
        bcc: [],
        subject: '',
        myHTML: ''
      },
      emailList: [],
      ccList: [],
      bccList: [],
      emailText: '',
      editTo: false,
      myHTML: '',
      files: []
    }
  },

  created () {
  },

  computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.editedItem.emails = []
          this.editedItem.cc = []
          this.editedItem.bcc = []
          this.editedItem.subject = ''
          this.editedItem.myHTML = ''
          this.files = []

          this.$emit('close', 'the test')
        }
      }
    }
  },

  watch: {
    visible (val) {
      if (val) {
        this.loadItem()
      }
    },
    editedItem: {
      handler: function (val, oldVal) {
        this.saving = true
      },
      deep: true
    },
    selectedItems: {
      handler: function (val, oldVal) {
        this.editedItem.emails = this.selectedItems.email
      }
    }
  },

  methods: {
    addFiles () {
      this.$refs.files.click()
    },

    handleFileUploads (e) {
      let uploadedFiles = e.target.files

      for (var i = 0; i < uploadedFiles.length; i++) {
        this.files.push(uploadedFiles[i])
      }
    },

    removeFile (key) {
      this.files.splice(key, 1)
    },

    loadItem () {
      this.emailList = this.items
      this.ccList = this.items
      this.bccList = this.items

      if (this.editedItem.emails.length > 9) {
        this.emailText = 'You are sending to ' + this.editedItem.emails.length + ' email addresses'
        this.editTo = false
      } else {
        this.emailText = ''
        this.editTo = true
      }
    },

    getTemplate (templateId) {
      const template = this.emailTemplates.find(({ id }) => id === templateId)
      console.log(template)
      this.editedItem.subject = template.subject
      this.editedItem.myHTML = template.text
    },

    async save () {
      let filenames = []
      let items = []

      for (let j in this.editedItem.emails) {
        let vars = this.rows.find(({ email }) => email === this.editedItem.emails[j])
        items[j] = vars
      }

      let formData = new FormData()
      formData.append('section', this.section)
      formData.append('to', this.editedItem.emails)
      formData.append('replyTo', this.editedItem.replyTo)
      formData.append('cc', this.editedItem.cc)
      formData.append('bcc', this.editedItem.bcc)
      formData.append('from', this.editedItem.from)
      formData.append('subject', this.editedItem.subject)
      formData.append('text', this.editedItem.myHTML)
      formData.append('vars', JSON.stringify(items))

      for (let i = 0; i < this.files.length; i++) {
        formData.append('files', this.files[i])
        console.log(this.files[i])
        filenames.push(this.files[i].name)
      }
      formData.append('filenames', filenames)

      try {
        const response = await Api().post('template_emails', formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })

        // this.show = false
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    }
  }
}
</script>

<style>
.centered-input input {
  text-align: center
}

input[type="file"]{
  position: absolute;
  top: -500px;
}

span.remove-file{
  color: red;
  cursor: pointer;
  float: right;
}

.scroll-here {
  overflow: auto;
  height: 340px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/forms/EmailTempForm.vue